<template>
  <div>
    <div v-if="loading">
      loading user profile ...
    </div>
    <div v-else>
      auth test
      <br />
      <button @click="login">kakao login</button>
      <button @click="logout">logout</button>
      <br />
      <code>current user is {{ JSON.stringify(user) }}</code>
      <br />
      <code>error: {{ JSON.stringify(error) }}</code>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import firebase from "firebase";

export default {
  name: "AuthTest",
  data() {
    return {
      user: null,
      loading: false,
      error: null
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(this.setUser);
  },
  methods: {
    setUser(user) {
      this.user = user;
    },
    login() {
      this.$KakaoSDK.Auth.login({
        success: async response => {
          this.loading = true;

          const apiUrl = process.env.VUE_APP_SPREADY_API_URL;

          try {
            const { access_token } = response;
            const { data } = await axios.post(`${apiUrl}/verify-token`, {
              token: access_token
            });
            console.log("data: ", data);
            const credentials = await firebase
              .auth()
              .signInWithCustomToken(data.token);
            console.log(credentials);
          } catch (error) {
            this.error = error;
          }

          this.loading = false;
        },
        fail: error => {
          this.error = error;
        }
      });
    },
    async logout() {
      this.loading = true;
      await firebase.auth().signOut();
      this.loading = false;
    }
  }
};
</script>
